// extracted by mini-css-extract-plugin
module.exports = {"simulatorContainer":"JobSimulator_simulatorContainer__3oXF9","paramInput":"JobSimulator_paramInput__2KVw_","input":"JobSimulator_input__1abvE"};